import api from "../../api.js";

/**
 * Reverse the latest accepted claim for a prescription, via whichever switching
 * house it was submitted to.
 * @param {number} prescriptionid
 * @returns {Promise<object>} { success, reversed, authNumber, reversedClaimAuth, messages, ... }
 */
export async function reverseClaim(prescriptionid) {
  // Longer than the app-wide 10s default: the switch house may take a while to answer.
  const res = await api.post("/api/reversal", { prescriptionid }, { timeout: 120000 });
  return res.data;
}
